<script setup lang="ts">
import { Check, X } from '@lucide/vue';
import { useToastStore } from '../stores/toast';

const toast = useToastStore();
</script>

<template>
  <div class="fixed left-4 bottom-4 z-[100] flex flex-col gap-2 pointer-events-none" aria-live="polite" role="status">
    <TransitionGroup name="toast">
      <div
        v-for="t in toast.toasts"
        :key="t.id"
        class="pointer-events-auto flex items-center gap-3 max-w-[calc(100vw-2rem)] rounded-[8px] bg-[#1c1b1b] text-white px-4 py-3 shadow-[0_10px_24px_-12px_rgba(0,0,0,0.5)]"
      >
        <span
          aria-hidden="true"
          :class="['grid place-items-center size-6 rounded-full shrink-0', t.kind === 'error' ? 'bg-[#ef4444]' : 'bg-[#10b981]']"
        >
          <X v-if="t.kind === 'error'" class="w-3.5 h-3.5" :stroke-width="2.5" />
          <Check v-else class="w-3.5 h-3.5" :stroke-width="2.5" />
        </span>
        <div class="flex flex-col">
          <p class="text-[14px] font-medium leading-tight">{{ t.message }}</p>
          <p v-if="t.subtext" class="text-[12px] text-white/70 leading-tight mt-0.5">{{ t.subtext }}</p>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.25s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(-16px);
}
.toast-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
.toast-leave-active {
  position: absolute;
}
</style>
